import AbstractScreenMediator from "../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import GameModel from "../model/GameModel";
import SaveModel from "../model/SaveModel";
import FeedbackPanelView from "../../../../../shared/src/ranj/equalture/view/FeedbackPanelView";

export default class AbstractFlexibilityScreenMediator extends AbstractScreenMediator {

    /**
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {GameModel} gameModel 
     * @param {SaveModel} saveModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameModel = gameModel;
        this._gameAssets = gameAssets;
        this._saveModel = saveModel;
    }

    checkSavegameRestoredFeedback(delay = 1000) {
        if (this._gameModel.restoredFeedbackPending) {
            this._gameModel.restoredFeedbackPending = false;
            this.callDelayed(this.showSavegameRestoredFeedback.bind(this), delay);
            return true;
        }
        return false;
    }

    showSavegameRestoredFeedback() {
        const str = this.getText("savegame.restored");
        const skin = new this._gameAssets.FeedbackPanel();
        skin.y = 320;
        this._target.addChild(skin);
        const view = new FeedbackPanelView(skin);
        view.addEventListener(FeedbackPanelView.CLOSE, () => {
            this._target.removeChild(skin);
        });
        view.setText(str, true);
    }
};
